<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <joint-ownership-listing
              [derrors]="derrors"
            ></joint-ownership-listing>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
